import React, { useState } from 'react';
import {
    Box,
    Popper,
    Paper,
    TextField,
    Switch,
    FormControlLabel,
    ClickAwayListener,
    Typography
} from '@mui/material';

const TechnologyFilter = ({ value, onChange, rowId, data }) => {
    console.log('data: ', data);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selected, setSelected] = useState(value ? value.split(', ') : []);



    const handleClick = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
        onChange(rowId, 'technology', selected.join(', '));
    };

    const handleToggle = (tech) => {
        const newSelected = selected.includes(tech)
            ? selected.filter(t => t !== tech)
            : [...selected, tech];
        setSelected(newSelected);
    };

    const open = Boolean(anchorEl);

    return (
        <ClickAwayListener onClickAway={handleClose}>
            <Box sx={{ width: '100%' }}>
                <TextField
                    fullWidth
                    value={value || ''}
                    placeholder="Select technology"
                    onClick={handleClick}
                    size="small"
                    InputProps={{
                        readOnly: true,
                        sx: { cursor: 'pointer', height: '36px' }
                    }}
                />
                <Popper
                    open={open}
                    anchorEl={anchorEl}
                    placement="bottom-start"
                    style={{ zIndex: 1300 }}
                >
                    <Paper
                        sx={{
                            width: 220,
                            maxHeight: 300,
                            overflow: 'auto',
                            mt: 0.5,
                            boxShadow: 3
                        }}
                    >
                        {/* Filter Input */}
                        <Box sx={{ p: 1, borderBottom: '1px solid #e0e0e0' }}>
                            <TextField
                                fullWidth
                                size="small"
                                placeholder="Filter..."
                                onClick={(e) => e.stopPropagation()}
                            />
                        </Box>

                        {/* Switch List */}
                        <Box>
                            {data?.map((tech) => (
                                <FormControlLabel
                                    key={tech}
                                    sx={{
                                        display: 'flex',
                                        width: '100%',
                                        m: 0,
                                        px: 1,
                                        py: 0.5,
                                        justifyContent: 'space-between',
                                        '&:hover': {
                                            backgroundColor: '#f5f5f5'
                                        }
                                    }}
                                    control={
                                        <Switch
                                            checked={selected.includes(tech)}
                                            onChange={() => handleToggle(tech)}
                                            size="small"
                                            sx={{
                                                '& .MuiSwitch-switchBase.Mui-checked': {
                                                    color: '#2196f3',
                                                },
                                                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                    backgroundColor: '#2196f3',
                                                },
                                            }}
                                        />
                                    }
                                    label={
                                        <Typography variant="body2" sx={{ fontSize: '14px' }}>
                                            {tech}
                                        </Typography>
                                    }
                                    labelPlacement="start"
                                />
                            ))}
                        </Box>
                    </Paper>
                </Popper>
            </Box>
        </ClickAwayListener>
    );
};

export default TechnologyFilter;
